const dynamicNews = {
  'dynamic-news-breadcrumbs': 'Новости',
  'dynamic-news-filter-title': 'Фильтр новостей',
  'dynamic-news-form-id-placeholder': 'ID новости',
  'dynamic-news-form-title-placeholder': 'Название новости',
  'dynamic-news-form-template-key-value-label': 'Значение в ключах',
  'dynamic-news-form-template-key-value-placeholder': 'Значение',
  'dynamic-news-preview-targets-label': 'Назначение',
  'dynamic-news-create-form-title-placeholder': 'Название новости',
  'dynamic-news-create-form-status-placeholder': 'Статус новости',
  'dynamic-news-create-form-upload-description-label': 'Кликните или переместите файл в зону загрузки',
  'dynamic-news-template-validation-error': 'Поле шаблона имеет ошибки в правилах валидации.',
  'dynamic-news-fields-priority': 'Сортировка полей',
  'dynamic-news-form-main-attribute': 'Основной атрибут',
};

export default dynamicNews;
